{
  "hero": {
    "eyebrow": "Per le aziende",
    "title": "Il consumo energetico",
    "highlight": "reso profittevole e sostenibile",
    "subtitle": "Contrattualizza impianti di energia rinnovabile dai quali ricevi profitti ricorrenti e Garanzie di Origine."
  },
  "bento": {
    "eyebrow": "L’ecosistema di soluzioni",
    "title": "Eleviamo le attuali strategie di consumo energetico rinnovabile delle aziende europee",
    "subtitle": "Soddisfando le esigenze di energy management, finance e sustainability.",
    "more": "Scopri di più"
  },
  "cases": {
    "eyebrow": "Casi di successo",
    "heading": "Per aziende di qualsiasi settore e dimensione",
    "sub": "Eleviamo la strategia energetica e di sostenibilità in base agli obiettivi della tua azienda.",
    "items": {
      "riduzione-prevedibile": {
        "title": "Azienda siderurgica riduce i suoi costi energetici del 24.7% con DEC Energy",
        "body": "Uno dei principali gruppi siderurgici europei, siglando un accordo da 14.4 GWh/anno con DEC Energy, si garantisce un risparmio prevedibile sui costi energetici per i prossimi 15 anni.",
        "link": "Scopri: Riduzione prevedibile dei costi"
      },
      "conformita": {
        "title": "Azienda packaging si assicura compliance decennale a SBTi con DEC Energy",
        "body": "Azienda packaging, soggetta a SBTi, trasforma il costo della conformità in un profitto ricorrente assicurandosi 10 anni di produzione di Garanzie di Origine con DEC Energy.",
        "link": "Scopri: Conformità future-proof e profittevole"
      },
      "ebitda": {
        "title": "Cartiera parte di un fondo di Private Equity migliora l’EBITDA con DEC Energy",
        "body": "Leader europeo nell’industria cartaria controllato da un fondo di Private Equity, migliora di 320 k€ il proprio EBITDA siglando un accordo decennale su un impianto da 7.2 MWp con DEC Energy.",
        "link": "Scopri: Migliora l'EBITDA"
      },
      "copertura-naturale": {
        "title": "Azienda dell’industria alimentare riduce la volatilità dei costi energetici del 27.94% con DEC Energy",
        "body": "Uno dei principali produttori alimentari italiani stabilizza ulteriormente il suo costo energetico generando profitti correlati al prezzo di mercato dell’elettricità.",
        "link": "Scopri: Riduci la volatilità dei costi energetici"
      },
      "impatto": {
        "title": "BancaStato eleva la sua strategia di sostenibilità con DEC Energy",
        "body": "Con la soluzione DEC Energy, BancaStato rafforza il proprio impegno a favore di iniziative orientate alla sostenibilità ambientale.",
        "link": "Scopri: Transizione energetica raccontabile"
      }
    }
  },
  "overview": {
    "head": "Contratto DEC Energy",
    "sub": [
      "nessuna installazione",
      "nessuna fornitura"
    ],
    "cowLine": "no, non è un PPA",
    "ctaTitle": "Scopri come rendere profittevole e sostenibile il tuo consumo energetico"
  },
  "bentoSbti": {
    "time": "TEMPO",
    "cost": "costo conformità",
    "marketLabel": "compliance senza DEC Energy",
    "zeroed": "costo GO azzerato",
    "withDec": "con DEC Energy"
  }
}
